import React, { useState } from "react";
import { fetchJson, getApiErrorMessage, API } from "../api";
import DeleteModal from "./DeleteModal";

function getFileExtension(url) {
  const match = url?.match(/\.([a-z0-9]+)$/i);
  return match ? match[1].toUpperCase() : "DOSYA";
}

function SoftwareCard({ software, index, showAdmin, onDelete }) {
  const [deleting, setDeleting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDelete = async (password) => {
    setDeleting(true);
    try {
      await fetchJson(API.delete, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password, index }),
      });
      setShowDeleteModal(false);
      onDelete();
    } catch (error) {
      window.alert(getApiErrorMessage(error));
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <article className={`rs-card${showAdmin ? " rs-card--admin" : ""}`}>
        <div className="rs-card__image-wrap">
          <img
            src={software.imageUrl}
            className="rs-card__image"
            alt={`${software.name} görseli`}
          />
          <span className="rs-card__badge">
            {getFileExtension(software.downloadUrl)}
          </span>
        </div>
        <div className="rs-card__body">
          <h3 className="rs-card__title">{software.name}</h3>
          {software.description && (
            <p className="rs-card__desc">{software.description}</p>
          )}
          <div className="rs-card__actions">
            <a
              href={software.downloadUrl}
              className="rs-btn rs-btn-primary"
              download
            >
              ↓ İndir
            </a>
            {showAdmin && (
              <button
                type="button"
                className="rs-btn rs-btn-danger"
                onClick={() => setShowDeleteModal(true)}
                disabled={deleting}
              >
                Sil
              </button>
            )}
          </div>
        </div>
      </article>

      {showDeleteModal && (
        <DeleteModal
          software={software}
          onConfirm={handleDelete}
          onCancel={() => setShowDeleteModal(false)}
          deleting={deleting}
        />
      )}
    </>
  );
}

export default SoftwareCard;
